(function() {
    'use strict';

    angular.module('eDocumentsApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('communication-action-definition', {
                parent: 'entity',
                url: '/communication-action-definition?page&sort&search',
                data: {
                    authorities: ['ROLE_SUPERADMIN'],
                    pageTitle: 'eDocumentsApp.communicationActionDefinition.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definitions.html',
                        controller: 'CommunicationActionDefinitionController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: [
                        '$stateParams',
                        'PaginationUtil',
                        function($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage($stateParams.page),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate($stateParams.sort),
                                ascending: PaginationUtil.parseAscending($stateParams.sort),
                                search: $stateParams.search
                            };
                        }
                    ],
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationActionDefinition');
                            $translatePartialLoader.addPart('communicationType');
                            $translatePartialLoader.addPart('communicationParameterType');
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }
                    ]
                }
            })
            .state('communication-action-definition-detail', {
                parent: 'communication-action-definition',
                url: '/communication-action-definition/{id}',
                data: {
                    authorities: ['ROLE_SUPERADMIN'],
                    pageTitle: 'eDocumentsApp.communicationActionDefinition.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('communicationActionDefinition');
                            $translatePartialLoader.addPart('communicationType');
                            $translatePartialLoader.addPart('communicationParameterType');
                            return $translate.refresh();
                        }
                    ],
                    readOnly: function() {
                        return true;
                    },
                    entity: [
                        '$stateParams',
                        'CommunicationActionDefinition',
                        function($stateParams, CommunicationActionDefinition) {
                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition-detail.edit', {
                parent: 'communication-action-definition-detail',
                url: '/detail/edit',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationActionDefinition',
                        function($stateParams, CommunicationActionDefinition) {
                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition.new', {
                parent: 'communication-action-definition',
                url: '/new',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        'CommunicationActionDefinition',
                        function(CommunicationActionDefinition) {
                            return new CommunicationActionDefinition();
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition.edit', {
                parent: 'communication-action-definition',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/communication-action-definition/communication-action-definition-dialog.html',
                        controller: 'CommunicationActionDefinitionDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [
                        '$stateParams',
                        'CommunicationActionDefinition',
                        function($stateParams, CommunicationActionDefinition) {
                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                        }
                    ],
                    readOnly: function() {
                        return false;
                    },
                    previousState: [
                        '$state',
                        function($state) {
                            return {
                                name: $state.current.name || 'communication-action-definition',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params)
                            };
                        }
                    ]
                }
            })
            .state('communication-action-definition.delete', {
                parent: 'communication-action-definition',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_SUPERADMIN']
                },
                onEnter: [
                    '$stateParams',
                    '$state',
                    '$uibModal',
                    function($stateParams, $state, $uibModal) {
                        $uibModal
                            .open({
                                templateUrl: 'app/entities/communication-action-definition/communication-action-definition-delete-dialog.html',
                                controller: 'CommunicationActionDefinitionDeleteController',
                                controllerAs: 'vm',
                                size: 'md',
                                resolve: {
                                    entity: [
                                        'CommunicationActionDefinition',
                                        function(CommunicationActionDefinition) {
                                            return CommunicationActionDefinition.get({ id: $stateParams.id }).$promise;
                                        }
                                    ]
                                }
                            })
                            .result.then(
                            function() {
                                $state.go('communication-action-definition', null, { reload: 'communication-action-definition' });
                            },
                            function() {
                                $state.go('^');
                            }
                        );
                    }
                ]
            });
    }
})();
